export function flattenMessages(obj, optOut?, optPaths?) {
	const out = optOut || {};
	const paths = optPaths || [];
	return Object.getOwnPropertyNames(obj).reduce((out, key) => {
		paths.push(key);
		if (typeof obj[key] === 'object') {
			flattenMessages(obj[key], out, paths);
		} else {
			out[paths.join('.')] = obj[key];
		}
		paths.pop();
		return out;
	}, out);
}

export interface ILocaleMessages {
	locale: string;
	messages: Record<string, string>;
}

export function initLocale(messages): ILocaleMessages {
	const locales = (
		navigator.language ||
		(navigator as any).browserLanguage || ['en', 'US']
	).split('-');
	const locale = locales[1]
		? `${locales[0]}-${locales[1].toUpperCase()}`
		: navigator.language || (navigator as any).browserLanguage;
	const localeMessages = messages[locale]
		? messages[locale]
		: messages['en-US'];

	return {
		locale,
		messages: localeMessages,
	};
}
